<i18n src='../../static/localization/controlPanel.json'></i18n>
<template lang="html">
  <div id="controlpanel">

    <nav class="navbar ">
      <div class="navbar-brand">
        <a class="navbar-item">
          <img src="https://staticcontentskymaps.blob.core.windows.net/static/static/logo_v2.png" alt="Skymaps">
        </a>

        

        <div class="navbar-burger burger" data-target="navMenubd-example">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <div id="navMenubd-example" class="navbar-menu">
        <div class="navbar-start">

        </div>

        <div class="navbar-end">
          <!-- <a class="navbar-item " href="http://bulma.io/expo/">Projects</a> -->
          <!-- <a class="navbar-item " href="http://bulma.io/love/">Support</a> -->
          <div class="navbar-item has-dropdown is-hoverable userProfile">
            <a class="navbar-link">
              <span class="icon user" style="color: #333;">{{userName}}
                <i class="fa fa-user"></i>
              </span>
            </a>
            <div class="navbar-dropdown">
              <router-link class="navbar-item logout" to="/logout">
                <a class="navbar-item logout">{{ $t('upperPanel.logout') }}</a> 
              </router-link>
              
            </div>
              
              
          </div>
        </div>
      </div>
    </nav>

    <!-- <div class="columns">
      <div class="column is-2 leftPanel">

      </div>
    </div> -->

    <div class="projects">
      <ul>
        <li v-for="project in projects">
          <router-link v-bind:to="'/map/'+project.id">
          <!-- <a v-bind:href="'/map/'+project.id"> -->
            <div class="card">
              <div class="card-image">
                <figure class="image">
                  <img v-bind:src="project.thumbnailImgUrl" alt="Image">
                </figure>
              </div>
              <div class="card-content">
                <div class="media">
                  <div class="media-content">
                    <p class="title is-4">{{ project.projectName }}</p>
                    <p class="subtitle is-6">{{ project.clientName }}</p>
                  </div>
                </div>

                <div class="content">
                  {{ project.meta.description }}
                  <br>
                  <small>{{ project.meta.date }}</small>
                </div>
              </div>
            </div>
          <!-- </a> -->
          </router-link>
        </li>
      </ul>
    </div>


  </div>
</template>

<script>
import { HTTP } from '../common/http'
import { mapGetters } from 'vuex'
import { store } from '../store/index'

export default {
  name: 'controlpanel',
  data () {
    return {
      projects: [],
      userId: JSON.parse(localStorage.getItem('credentials')).email,
      userName: JSON.parse(localStorage.getItem('profile')).name
    }
  },
  mounted () {
    this.$i18n.locale = JSON.parse(localStorage.getItem('profile')).lang
    //console.log(localStorage.getItem('token'));
    HTTP.get('/projects/byUser/'+ this.userId, {
      headers: {
        'token': localStorage.getItem('token'),
        'user': JSON.parse(localStorage.getItem('credentials')).email
      }
    }).then(response => {
      this.projects = response.data.data
    }).catch(error => {
      console.log(error)
    })
  },
  methods: {

  },
  computed: mapGetters([
    'getCurrentUser'
  ])
}
</script>

<style lang="css" scoped>
  #controlpanel{
    height: 100%;
    overflow: scroll;
  }
  .columns{
    height: 100%;
    position: relative;
    margin: 0 0 0 0;
  }
  .leftPanel{
    background: #354555;
  }
  .navbar{
    background: #228D7A;
    border-bottom: 1px solid #82a6d2;
  }
  a.navbar-item:hover, a.navbar-item.is-active, .navbar-link:hover, .navbar-link.is-active{
    background-color: #658eab;
  }
  .navbar-brand a:hover{
    background: none;
    cursor: auto;
  }
  .navbar-item, .navbar-link{
    color: #FFFFFF;
    padding: 0rem 1rem;
  }
  .navbar-item img{
    max-height: 2.75rem;
  }
  .navbar-dropdown{
    border-radius: 0px;
  }

  .projects{
    /* position: absolute; */
    /* width: 100%; */
    /* margin: 50px; */
  }
  .projects li{
    width: 265px;
    display: inline-block;
    margin: 25px;
  }
  .logout{
    color: #000000;
    text-transform: uppercase;
  }
  
  .navbar-dropdown .logout:hover {
    background: none;
  }
  .userProfile{
    padding-right: 0px;
  }
  .userProfile .navbar-link{
    border-left: 0.5px solid #666e82;
  }
  .navbar-item.has-dropdown:hover .navbar-link, .navbar-item.has-dropdown.is-active .navbar-link{
    background: none;
  }
  .userProfile .navbar-link::after{
    border: none;
  }
  .userProfile .navbar-link:hover{
    background: #018083;
  }
  .userProfile .navbar-dropdown{
    left: auto;
  }

  .user{
    width: auto;
    color: #FFFFFF !important;
    font-size: 16px;
    text-transform: uppercase;
  }
  .user i{
    padding-left: 20px;
    color: #000000;
  }
  .media-content{
    text-align: center;
  }
  .image{
    height: 230px;
  }
  .image img{
    display: inherit;
    width: auto;
    max-height: 100%;
    margin: 0 auto;
  }
  .card-content .content{
    text-align: center;
  }
  .card{
    padding-top: 20px;
    padding-bottom: 20px;
  }

</style>



// WEBPACK FOOTER //
// ControlPanel.vue?177e2dda